var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFormWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.5076 10.613L10.241 2.93301C9.66763 1.89967 8.87429 1.33301 8.00096 1.33301C7.12763 1.33301 6.33429 1.89967 5.76096 2.93301L1.49429 10.613C0.954295 11.593 0.894295 12.533 1.32763 13.273C1.76096 14.013 2.61429 14.4197 3.73429 14.4197H12.2676C13.3876 14.4197 14.241 14.013 14.6743 13.273C15.1076 12.533 15.0476 11.5863 14.5076 10.613Z",
    fill: "#E87A16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.83333C7.72667 9.83333 7.5 9.60667 7.5 9.33333V6C7.5 5.72667 7.72667 5.5 8 5.5C8.27333 5.5 8.5 5.72667 8.5 6V9.33333C8.5 9.60667 8.27333 9.83333 8 9.83333Z",
    fill: "#E87A16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 12C7.96065 12 7.91398 11.9934 7.86732 11.9867C7.82732 11.98 7.78732 11.9667 7.74732 11.9467C7.70732 11.9334 7.66732 11.9134 7.62732 11.8867C7.59398 11.86 7.56065 11.8334 7.52732 11.8067C7.40732 11.68 7.33398 11.5067 7.33398 11.3334C7.33398 11.16 7.40732 10.9867 7.52732 10.86C7.56065 10.8334 7.59398 10.8067 7.62732 10.78C7.66732 10.7534 7.70732 10.7334 7.74732 10.72C7.78732 10.7 7.82732 10.6867 7.86732 10.68C7.95398 10.66 8.04732 10.66 8.12732 10.68C8.17398 10.6867 8.21398 10.7 8.25398 10.72C8.29398 10.7334 8.33398 10.7534 8.37398 10.78C8.40732 10.8067 8.44065 10.8334 8.47398 10.86C8.59398 10.9867 8.66732 11.16 8.66732 11.3334C8.66732 11.5067 8.59398 11.68 8.47398 11.8067C8.44065 11.8334 8.40732 11.86 8.37398 11.8867C8.33398 11.9134 8.29398 11.9334 8.25398 11.9467C8.21398 11.9667 8.17398 11.98 8.12732 11.9867C8.08732 11.9934 8.04065 12 8.00065 12Z",
    fill: "#E87A16"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFormWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-form-warning.eb6c59ae997065d81d1dbeb70f2b0132.svg";